import { render, staticRenderFns } from "./sdhz.vue?vue&type=template&id=8cde0086&scoped=true&"
import script from "./sdhz.vue?vue&type=script&lang=js&"
export * from "./sdhz.vue?vue&type=script&lang=js&"
import style0 from "./sdhz.vue?vue&type=style&index=0&id=8cde0086&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cde0086",
  null
  
)

export default component.exports